import script from "./payMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./payMethod.vue?vue&type=script&setup=true&lang=js"

import "./payMethod.vue?vue&type=style&index=0&id=9c7548b2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c7548b2"]])

export default __exports__